import { estimatedTemplatePrice } from 'dashboard/helper/whatsappPricing';

const STATUS_GROUPS = {
  APPROVED: 'APPROVED',
  REINSTATED: 'APPROVED',
  PENDING: 'IN_REVIEW',
  IN_REVIEW: 'IN_REVIEW',
  IN_APPEAL: 'IN_REVIEW',
  REJECTED: 'REJECTED',
  PAUSED: 'PAUSED',
  DISABLED: 'PAUSED',
  FLAGGED: 'PAUSED',
  LOCKED: 'PAUSED',
  LIMIT_EXCEEDED: 'PAUSED',
  ARCHIVED: 'ARCHIVED',
};

const GROUP_STYLES = {
  APPROVED: 'bg-n-teal-3 text-n-teal-11',
  IN_REVIEW: 'bg-n-amber-3 text-n-amber-11',
  PAUSED: 'bg-n-amber-3 text-n-amber-11',
  REJECTED: 'bg-n-ruby-3 text-n-ruby-11',
  ARCHIVED: 'bg-n-slate-3 text-n-slate-11',
};

export const KNOWN_STATUSES = Object.keys(STATUS_GROUPS);
export const FILTER_GROUPS = [
  'APPROVED',
  'IN_REVIEW',
  'REJECTED',
  'PAUSED',
  'ARCHIVED',
];
export const EDITABLE_STATUSES = ['APPROVED', 'REJECTED', 'PAUSED'];
export const REVIEW_STATUSES = ['PENDING', 'IN_REVIEW', 'IN_APPEAL'];
export const KNOWN_REASONS = [
  'ABUSIVE_CONTENT',
  'SCAM',
  'PROMOTIONAL',
  'INCORRECT_CATEGORY',
  'TAG_CONTENT_MISMATCH',
  'INVALID_FORMAT',
];
export const CATEGORY_REASONS = ['INCORRECT_CATEGORY', 'TAG_CONTENT_MISMATCH'];
export const PAUSE_TITLES = [
  'FIRST_PAUSE',
  'SECOND_PAUSE',
  'RATE_LIMITING_PAUSE',
  'UNPAUSE',
  'DISABLED',
];

const normalize = value => value?.toUpperCase();

export const statusGroup = status =>
  STATUS_GROUPS[normalize(status)] || 'PAUSED';

// Same keys the inbox tab uses; a status Meta adds later stays as sent instead of showing a missing key.
export const statusLabel = (status, t) => {
  const key = normalize(status);
  if (key === 'UNSUBMITTED')
    return t('WHATSAPP_TEMPLATE_MGMT.STATUSES.UNSUBMITTED');
  return KNOWN_STATUSES.includes(key)
    ? t(`WHATSAPP_TEMPLATES.MANAGER.STATUS.${key}`)
    : status;
};

export const statusStyle = status =>
  normalize(status) === 'DISABLED'
    ? GROUP_STYLES.REJECTED
    : GROUP_STYLES[statusGroup(status)];

export const isInReview = template =>
  REVIEW_STATUSES.includes(normalize(template.status));

export const canEditTemplate = template =>
  EDITABLE_STATUSES.includes(normalize(template.status));

export const reasonKey = template => {
  const reason = normalize(template.rejected_reason);
  return KNOWN_REASONS.includes(reason) ? reason : null;
};

export const reasonLabel = (template, t) => {
  const key = reasonKey(template);
  if (key) return t(`WHATSAPP_TEMPLATES.MANAGER.REASON.${key}`);
  const raw = template.rejected_reason;
  return raw && normalize(raw) !== 'NONE' ? raw : '';
};

export const pauseLabel = (template, t) => {
  const title = normalize(template.other_info?.title);
  return PAUSE_TITLES.includes(title)
    ? t(`WHATSAPP_TEMPLATES.MANAGER.PAUSE.${title}`)
    : '';
};

export const qualityScore = template => {
  const score = normalize(template.quality_score?.score);
  return ['GREEN', 'YELLOW', 'RED'].includes(score) ? score : null;
};

export const qualityAlert = template => {
  const score = qualityScore(template);
  return score === 'YELLOW' || score === 'RED' ? score : null;
};

// Categoria que a Meta trocou (previous_category vem do sync ou do webhook)
// e categoria que ela avisou que vai trocar (pending_category).
export const categoryChange = template => {
  const from = normalize(template.previous_category);
  const to = normalize(template.category);
  if (!from || !to || from === to) return null;
  const price = category => estimatedTemplatePrice(category) ?? 0;
  return { from, to, costlier: price(to) > price(from) };
};

export const pendingCategory = template => {
  const category = normalize(template.pending_category?.category);
  if (!category || category === normalize(template.category)) return null;
  return { category, effectiveAt: template.pending_category.effective_at };
};
